/** Shared prod/pre-prod host helpers. Safe for Vercel Node + Edge (no src/ imports). */

export const PROD_HOST = 'calendarify.online';
export const PRE_PROD_HOST = 'pre-prod.calendarify.online';

export function normalizeHost(hostname: string): string {
  return hostname.toLowerCase().split(':')[0];
}

export function isProdHost(hostname: string): boolean {
  const host = normalizeHost(hostname);
  return host === PROD_HOST || host === `www.${PROD_HOST}`;
}

export function isPreProdHost(hostname: string): boolean {
  return normalizeHost(hostname) === PRE_PROD_HOST;
}

export type PreProdSignals = {
  hostname?: string;
  noIndexFlag?: string;
  gitBranch?: string;
};

/**
 * Production host always wins — safe to merge to main.
 * See specs/environments.md.
 */
export function shouldBlockIndexing(signals: PreProdSignals): boolean {
  if (signals.hostname && isProdHost(signals.hostname)) {
    return false;
  }
  if (signals.hostname && isPreProdHost(signals.hostname)) {
    return true;
  }
  if (signals.noIndexFlag === 'true') {
    return true;
  }
  if (signals.gitBranch === 'pre-prod') {
    return true;
  }
  return false;
}
